import { createSlice } from '@reduxjs/toolkit';

const registrySlice = createSlice({
  name: 'registry',
  initialState: { result: [] },
  reducers: {
    hydrateResult: (state, { payload }) => {
      state.result = payload;
    },
  },
});

export const { hydrateResult } = registrySlice.actions;
export default registrySlice.reducer;
